import { ArrowRight, Fuel, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Map, MapBoundsListener, MapFullscreenControl, MapLocateControl, MapMarker, MapMarkerClusterGroup, MapPopup, MapTileLayer, MapZoomControl } from '../ui/map';

function bucketClass(price, min, max) {
  if (!Number.isFinite(price)) return 'bg-md-secondary text-md-on-secondary';
  const span = Math.max(.001, max - min);
  const ratio = (price - min) / span;
  if (ratio < .33) return 'bg-md-secondary text-md-on-secondary';
  if (ratio < .66) return 'bg-md-tertiary-container text-md-on-tertiary-container';
  return 'bg-md-primary text-md-on-primary';
}

export default function FuelMap({ data, height = 620, onBoundsChange }) {
  const features = data?.features || [];
  const prices = features.map(f => Number(f.properties?.price)).filter(Number.isFinite);
  const min = prices.length ? Math.min(...prices) : 0;
  const max = prices.length ? Math.max(...prices) : 0;

  return (
    <div style={{ height }}>
      <Map center={[42.3, 12.5]} zoom={6} className="h-full min-h-0 rounded-none border-0">
        <MapTileLayer />
        <MapZoomControl />
        <MapFullscreenControl />
        <MapLocateControl />
        <MapBoundsListener onChange={onBoundsChange} />
        <MapMarkerClusterGroup>
          {features.map(f => {
            const [lng, lat] = f.geometry.coordinates;
            const p = f.properties || {};
            const price = Number(p.price);
            return (
              <MapMarker
                key={p.id_impianto}
                position={[lat, lng]}
                icon={
                  <div className={`grid h-10 min-w-10 place-items-center rounded-[18px_18px_6px_18px] px-2 text-[11px] font-bold shadow-md2 ${bucketClass(price, min, max)}`}>
                    {Number.isFinite(price) ? price.toFixed(2) : '—'}
                  </div>
                }
              >
                <MapPopup>
                  <div className="min-w-[220px] p-1 font-roboto">
                    <div className="flex items-start gap-3">
                      <div className="grid h-10 w-10 shrink-0 place-items-center rounded-[14px] bg-md-primary-container text-md-on-primary-container"><Fuel className="h-5 w-5" /></div>
                      <div className="min-w-0">
                        <div className="font-bold text-md-on-surface">{p.name}</div>
                        <div className="mt-1 flex items-start gap-1 text-xs leading-5 text-md-on-surface-variant"><MapPin className="mt-0.5 h-3.5 w-3.5 shrink-0" />{[p.brand, p.municipality, p.province].filter(Boolean).join(' · ')}</div>
                      </div>
                    </div>
                    <div className="numbers mt-4 text-3xl font-bold tracking-[-0.035em] text-md-on-surface">{Number.isFinite(price) ? `${price.toFixed(3)} €` : '—'}</div>
                    <Link className="mt-4 inline-flex min-h-10 items-center gap-2 rounded-full bg-md-primary px-4 text-sm font-medium text-md-on-primary" to={`/impianti/${p.id_impianto}`}>
                      Storico giornaliero <ArrowRight className="h-4 w-4" />
                    </Link>
                  </div>
                </MapPopup>
              </MapMarker>
            );
          })}
        </MapMarkerClusterGroup>
      </Map>
    </div>
  );
}
